import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Control } from 'react-redux-form';
import queryString from 'query-string';
import { Button } from 'react-bootstrap';
import ControlGroup from '../forms/ControlGroup';
import history from '../../shared_history';

const RadioFilter = ({
  location, options, label, fieldName, defaultOption, model, hideSubmit, vertical
}) => {
  const query = queryString.parse(location.search);
  const [selected, setSelected] = useState(query[fieldName] || defaultOption);

  const updateUrl = (newOption) => {
    const searchParams = { ...query };
    searchParams[fieldName] = typeof newOption === 'object' ? selected : newOption;

    history.push({
      ...location,
      search: `?${queryString.stringify(searchParams)}`
    });
  };

  const setSelectedAndSubmit = (newOption) => {
    setSelected(newOption);
    updateUrl(newOption);
  };

  useEffect(() => {
  }, [])

  return (
    <div>
      <ControlGroup label={label}>
        {vertical === true ? <br clear='all' /> : ''}
        {Object.keys(options).map((k) => (
          <label className={"radio-filter-label" + (vertical === true ? ' vertical' : '')}>
            <Control.checkbox
              type='radio'
              value={k}
              className='radio-filter-btn'
              model={model}
              onClick={() => {  hideSubmit === false ? setSelected(k) : setSelectedAndSubmit(k) }}
              defaultChecked={selected === k}
            />
            {options[k]}
            &nbsp;&nbsp;&nbsp;&nbsp;
          </label>
        ))}
        {hideSubmit === false
          ? <Button onClick={updateUrl}>Submit</Button>
          : ''
        }
      </ControlGroup>
    </div>
  );
};

RadioFilter.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string
  }).isRequired,
  options: PropTypes.object,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  defaultOption: PropTypes.string,
  hideSubmit: PropTypes.bool,
  vertical: PropTypes.bool
};
RadioFilter.defaultProps = {
  options: {},
  label: '',
  fieldName: '',
  defaultOption: '',
  hideSubmit: false,
  vertical: false
};

export default (connect()(RadioFilter));
